import { render, staticRenderFns } from "./WidgetTopBar.vue?vue&type=template&id=6d193c54&scoped=true"
import script from "./WidgetTopBar.vue?vue&type=script&lang=js"
export * from "./WidgetTopBar.vue?vue&type=script&lang=js"
import style0 from "./WidgetTopBar.vue?vue&type=style&index=0&id=6d193c54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d193c54",
  null
  
)

export default component.exports